import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/Users/dave/checkouts/pyohio/static-website/node_modules/gatsby-theme-catalyst-core/src/components/layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Seo = makeShortcode("Seo");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <Seo title="PyOhio Schedule" mdxType="Seo" />
    <h1 {...{
      "id": "schedule"
    }}>{`Schedule`}</h1>
    <p>{`PyOhio will be July 31, 2021 with the video stream starting at 9am EDT.`}</p>
    <blockquote>
      <p parentName="blockquote">{`Schedule for `}<a parentName="p" {...{
          "href": "/2021/program/talks"
        }}>{`specific talks`}</a>{` will be announced closer to the event.`}</p>
    </blockquote>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Time (EDT)`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Session`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`9:00am`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Opening Remarks`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`9:05am`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Keynote`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`9:30am-TBD`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Lightning & Thunder Talks`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`TBD`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Break`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`TBD-(mid-afternoon)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Lightning & Thunder Talks + Close`}</td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      